/* eslint-disable camelcase */
import React, {
} from 'react';
import {
  DateTime,
} from 'luxon';

import {
  Button,
} from 'web-components';
import {
  Flex,
  Text,
} from 'web-styled';

import SubscriptionItem from './SubscriptionItem';

import * as S from '../styled';

const getNextText = (subscription) => {
  let text = subscription.cancel_at_period_end ? 'Subscribed Until' : 'Next Payment';
  if (subscription.status === 'past_due') { text = 'Next Payment Attempt'; }
  return text;
};

type Props = {
  isPro: boolean,
  subscriptions: any[],
  lastFailedInvoice: any,
  paymentAttempt: { (): void },
  cancelSubscription: { (subscription: any): void },
};

const SubscriptionData = ({
  isPro,
  subscriptions,
  paymentAttempt,
  lastFailedInvoice,
  cancelSubscription,
}: Props) => (
  <>
    <Flex
      width="100%"
      column
      flex="0 0 70%"
    >
      {subscriptions.map(subscription => (
        <SubscriptionItem
          key={subscription.id}
          isPro={isPro}
          subscription={subscription}
          onCancel={() => cancelSubscription(subscription)}
        />
      ))}
    </Flex>

    {subscriptions[0]?.current_period_end && (
      <>
        <S.SectionCaption>
          {getNextText(subscriptions[0])}
        </S.SectionCaption>
        <Flex
          flex="0 0 calc(22% - 32px)"
          width="100%"
          column
          justify="center"
          align="center"
          spacing={15}
          padding="15px"
        >
          <Text
            size="22px"
            weight="600"
            color="303032"
          >
            {DateTime.fromMillis(subscriptions[0]?.current_period_end * 1000).toFormat('MMMM dd, yyyy')}
          </Text>
          {lastFailedInvoice && (
            <Button
              appearance="primary"
              onClick={paymentAttempt}
            >
              Make Payment Attempt
            </Button>
          )}
        </Flex>
      </>
    )}
  </>
);

export default SubscriptionData;
